/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { PreventiveSheetTemplateCheck } from '../../../model/PreventiveSheetTemplateCheck';
import { PreventiveSheetTemplate } from '../../../model/PreventiveSheetTemplate';
import { BaseController } from '../../BaseController';

class PreventiveSheetTemplateViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, preventiveSheetTemplateService, waitSpinnerService, $q, $state, $stateParams, $log,
        notificationService, domainService, filterService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.preventiveSheetTemplateService = preventiveSheetTemplateService;
        this.domainService = domainService;
        this.filterService = filterService;
        this.$log.debug('Controller \'PreventiveSheetTemplateView\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.formDisabled = false;
        this.domains = [];
        this.checkTypes = ['BOOLEAN','INFO', 'LABEL','TEXT_AREA','SELECT', 'LIST', 'NUMBER', 'DATE', 'DATE_TIME', 'URL'].map(dataType => {
            return {
                name: `model.preventivesheettemplate.check.type.${dataType}`,
                type: dataType
            };
        });
        this.part = null;
        this.check = new PreventiveSheetTemplateCheck();
        this.preventiveSheetTemplate = new PreventiveSheetTemplate();

        // The updateMode flag can be used to know the context in which this controller is running: creation or update.
        let initPromise;
        let domainPromise;
        if (this.$stateParams.hasOwnProperty('id')) {
            this.updateMode = true;
            this.title = 'ui.preventivesheettemplate.update';
            initPromise = this.preventiveSheetTemplateService.getEntity(this.$stateParams.id);
            domainPromise = [];
        } else {
            this.updateMode = false;
            this.title = 'ui.preventivesheettemplate.creation';
            initPromise = this.$q.resolve();
            domainPromise = this.domainService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'name'})
            });
        }

        this.handleRestServiceCall(this.$q.all({
            entity: initPromise,
            domains: domainPromise
        }), data => {
            this.pristineEntity = new PreventiveSheetTemplate(data.entity);
            this.domains = data.domains;
            this.reset();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    addCheck() {
        let error = false;
        if (this.preventiveSheetTemplate.findDuplicatedName(angular.copy(this.check))) {
            error = true;
            this.notificationService.pushMessage('ui.preventivesheettemplate.addnamecheckerror',
                this.configuration.NOTIFIER_LEVEL_ERROR);
        }
        if (this.preventiveSheetTemplate.findKeyDuplicated(angular.copy(this.check))) {
            error = true;
            this.notificationService.pushMessage('ui.preventivesheettemplate.addkeycheckerror',
                this.configuration.NOTIFIER_LEVEL_ERROR);
        }
        if (!error) {
            this.preventiveSheetTemplate.addCheck(angular.copy(this.check))
        }
    }

    removeCheck(check) {
        this.preventiveSheetTemplate.removeCheck(check);
    }

    save() {
        this.formDisabled = true;
        let serviceActionPromise;
        if (this.updateMode) {
            serviceActionPromise = this.preventiveSheetTemplateService.updateEntity(this.preventiveSheetTemplate);
        } else {
            serviceActionPromise = this.preventiveSheetTemplateService.createEntity(this.preventiveSheetTemplate);
        }
        this.handleRestServiceCall(serviceActionPromise, () => {
            const message = 'ui.preventivesheettemplate.' + (this.updateMode ? 'updated' : 'created');
            this.notificationService.pushMessage(message, this.configuration.NOTIFIER_LEVEL_INFO);
            if (this.updateMode) {
                this.$state.reload();
            } else {
                this.$state.go('gmao.preventivesheet.template.list');
            }        }).finally(() => {
            this.formDisabled = false;
        });
    }

    reset() {
        this.preventiveSheetTemplate = angular.copy(this.pristineEntity);
    }
}

export const preventiveSheetTemplateViewComponent = {
    template: require('./preventivesheettemplate-view.html'),
    controller: PreventiveSheetTemplateViewController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/component/PreventiveSheetTemplateView.js